import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { get, some } from "lodash";
import { CircularProgress, IconButton } from "@mui/material";
import { FavoriteBorder, Favorite } from "@mui/icons-material";
import { toggleFavoriteForUser } from "../../store/user/actions";

const FavoriteButton = ({ sx, menuItemId }) => {
  const dispatch = useDispatch();
  const userDetails = useSelector(({ user: { userDetails } }) => userDetails);
  const userFavorites = get(userDetails, "data.favoriteItems", []);
  const [isFavorited, setIsFavorited] = useState(
    some(userFavorites, (item) => item.menuItemId === menuItemId)
  );
  const [isLoading, setIsLoading] = useState(true);

  // Sync the local state when userFavorites changes
  useEffect(() => {
    const favorited = some(
      userFavorites,
      (item) => item.menuItemId === menuItemId
    );
    setIsFavorited(favorited);
    setIsLoading(false);
  }, [menuItemId, userFavorites]);

  const handleToggleFavorite = (e) => {
    e.stopPropagation();
    setIsLoading(true);
    dispatch(toggleFavoriteForUser(menuItemId, !isFavorited));
  };

  return (
    <IconButton
      onClick={handleToggleFavorite}
      aria-label="add to favorites"
      sx={{
        "& .MuiSvgIcon-root": {
          margin: 0,
        },
        ...sx
      }}
    >
      {isLoading ? (
        <CircularProgress size={24} />
      ) : isFavorited ? (
        <Favorite color="primary" />
      ) : (
        <FavoriteBorder />
      )}
    </IconButton>
  );
};

export default FavoriteButton;
